export default "__VITE_ASSET__dd50bab7__"